import { render, staticRenderFns } from "./QuotazioneDirettaForm.vue?vue&type=template&id=dc521a1c"
import script from "./QuotazioneDirettaForm.vue?vue&type=script&lang=js"
export * from "./QuotazioneDirettaForm.vue?vue&type=script&lang=js"
import style0 from "./QuotazioneDirettaForm.vue?vue&type=style&index=0&id=dc521a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports